/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserType } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserType';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserTypeFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserTypeFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserTypeToJSON,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserType';

/**
 * User who deleted the referral associated with this fax, if applicable
 * @export
 * @interface FaxDocumentReferralDeletedByUser
 */
export interface FaxDocumentReferralDeletedByUser {
    /**
     * 
     * @type {string}
     * @memberof FaxDocumentReferralDeletedByUser
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FaxDocumentReferralDeletedByUser
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof FaxDocumentReferralDeletedByUser
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof FaxDocumentReferralDeletedByUser
     */
    title?: string;
    /**
     * 
     * @type {FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserType}
     * @memberof FaxDocumentReferralDeletedByUser
     */
    user_type?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserType;
    /**
     * 
     * @type {string}
     * @memberof FaxDocumentReferralDeletedByUser
     */
    photo_url?: string;
}

/**
 * Check if a given object implements the FaxDocumentReferralDeletedByUser interface.
 */
export function instanceOfFaxDocumentReferralDeletedByUser(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FaxDocumentReferralDeletedByUserFromJSON(json: any): FaxDocumentReferralDeletedByUser {
    return FaxDocumentReferralDeletedByUserFromJSONTyped(json, false);
}

export function FaxDocumentReferralDeletedByUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): FaxDocumentReferralDeletedByUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'user_type': !exists(json, 'user_type') ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserTypeFromJSON(json['user_type']),
        'photo_url': !exists(json, 'photo_url') ? undefined : json['photo_url'],
    };
}

export function FaxDocumentReferralDeletedByUserToJSON(value?: FaxDocumentReferralDeletedByUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'title': value.title,
        'user_type': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserTypeToJSON(value.user_type),
        'photo_url': value.photo_url,
    };
}

